import moment from 'moment'
import { Form, Row } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { ProjectFormButtonContinue } from '../index'
import { ContentFormPayload } from 'src/core/models'
import { FormLabels, CustomCol } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { projectFormContentSections } from './project-form-content.sections'
import {
  isProjectDescriptionErrorVisible,
  projectFormContentImagesSelector,
  setProjectFormContentValues,
  projectFormIsActiveSelector,
  setProjectFormItemValue,
  formContentSelector,
} from 'src/features'

const ProjectFormContent: React.FC = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const isDescriptionErrorVisible = useAppSelector(isProjectDescriptionErrorVisible)
  const isActive = useAppSelector(projectFormIsActiveSelector)
  const contentImages = useAppSelector(projectFormContentImagesSelector)
  const sections = projectFormContentSections(t, dispatch, contentImages, isActive)
  const formContent = useAppSelector(formContentSelector)

  const onFinish = (values: ContentFormPayload) => {
    if (isDescriptionErrorVisible) return
    dispatch(setProjectFormContentValues(values))
    dispatch(setProjectFormItemValue({ key: 'activeStep', value: 'STOCK' }))
  }

  useEffect(() => {
    form.setFieldsValue({
      ['name']: formContent.name,
      ['url']: formContent.url,
      ['registered_since']: formContent.registered_since && moment(new Date(formContent.registered_since)),
      ['video']: formContent.video,
      ['sdg_compliances']: formContent.sdg_compliances,
      ['main_image']: formContent.main_image,
      ['description_en']: formContent.description_en,
      ['description_es']: formContent.description_es,
      ['description_fr']: formContent.description_fr,
      ['description_ko']: formContent.description_ko,
      ['description_de']: formContent.description_de,
      ['description_pt']: formContent.description_pt,
      ['description_it']: formContent.description_it,
      ['description_pl']: formContent.description_pl,
      ['description_zh']: formContent.description_zh,
      ['headline_en']: formContent.headline_en,
      ['headline_es']: formContent.headline_es,
      ['headline_fr']: formContent.headline_fr,
      ['headline_ko']: formContent.headline_ko,
      ['headline_de']: formContent.headline_de,
      ['headline_pt']: formContent.headline_pt,
      ['headline_it']: formContent.headline_it,
      ['headline_pl']: formContent.headline_pl,
      ['headline_zh']: formContent.headline_zh,
    })
  }, [form, formContent])


  return <>
    <Form
      onFinish={onFinish}
      form={form}
    >
      {sections.map((section, idx) => <div key={idx}>
        {section.isRow ? (
          <Row className={section.rowClassName}>
            <CustomCol>
              <FormLabels {...section.labels} />
            </CustomCol>

            <CustomCol>
              <section.formComponent {...section.formProps} />
            </CustomCol>
          </Row>
        ): !section.isRow ? <>
          <FormLabels {...section.labels} />
          <section.formComponent {...section.formProps} />
        </>: section.isOnlyComponent && <section.formComponent />}
      </div>
      )}

      <ProjectFormButtonContinue />
    </Form>
  </>
}

export default ProjectFormContent
